import { useQuery } from '@tanstack/react-query';

import { HomeStatistics } from 'src/features/home/types';
import axios from 'src/lib/axios';
import { ListDTO } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/stats/home-stats/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
}
const queryFn = ({ parkingId, ...params }: DTO): Promise<HomeStatistics> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_HOME_STATISTICS_RESOURCE, useQueryHook as useListHomeStatistics };
